import * as Sentry from "@sentry/react";

type ErrorContext = {
  tags?: Record<string, string | number>;
  extra?: Record<string, unknown>;
};

export const SENTRY_DSN = import.meta.env.VITE_FRONTEND_SENTRY_DSN;

export function initSentry(): void {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: import.meta.env.VITE_ENV || "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration(),
      Sentry.replayIntegration(),
    ],
    enableLogs: true,
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
  });
}

export function sendErrorToSentry(
  error: unknown,
  context?: ErrorContext,
): void {
  if (!SENTRY_DSN) {
    return;
  }
  Sentry.captureException(error, {
    tags: context?.tags,
    extra: context?.extra,
  });
}

export { Sentry };
